import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitSizeDTO } from 'features/globalSetup/features/viewport'
import { adUnitSizeFromDTO } from 'features/globalSetup/features/viewport/utils'
import { AdUnitRefresherDTO } from 'features/inventory/api/types/adUnitRefresherDTO'
import { AdUnitRefresher } from 'features/inventory/types/adUnitRefresher'
import { floatPercentFromDTO, millisecondsToSeconds } from 'utils/number'

type From = AdUnitRefresherDTO
type To = AdUnitRefresher

export const adUnitRefresherFromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((adUnitRefresherDTO: From): To => {
    const {
      adUnitId,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold,
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval,
      externalAdUnitPath,
      id,
      mobileAdThreshold,
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval,
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      sizes,
      updatedAt,
    } = adUnitRefresherDTO

    return {
      additionalSizes: sizes.map((size: AdUnitSizeDTO): string => adUnitSizeFromDTO(size)),
      adUnitId,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: floatPercentFromDTO(desktopAdThreshold),
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: millisecondsToSeconds(desktopRefreshInterval),
      id,
      mobileAdThreshold: floatPercentFromDTO(mobileAdThreshold),
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: millisecondsToSeconds(mobileRefreshInterval),
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      targetAdUnitPath: externalAdUnitPath ?? undefined,
      updatedAt: new Date(updatedAt),
    }
  })
